import { Routes } from '@angular/router'
import { RoutesEnum } from '@ui-core/enums/routes.enum'
import { AuthGuard } from '@ui-core/guards/auth.guard'

export const dashboardRoutes: Routes = [
    {
        path: '',
        redirectTo: RoutesEnum.DASHBOARD,
        pathMatch: 'full'
    },
    {
        path: RoutesEnum.DASHBOARD,
        loadComponent: () => import('./dashboard').then((m) => m.Dashboard),
        canActivate: [AuthGuard]
    }
]
